import { useEffect, useState } from "react";

export type SSEConnectionStatus = "connecting" | "connected" | "disconnected";

/**
 * Monitors the SSE connection status.
 * Returns "connected" when events are flowing, "disconnected" when the connection drops.
 */
export function useSSEStatus(url: string): SSEConnectionStatus {
  const [status, setStatus] = useState<SSEConnectionStatus>("connecting");

  useEffect(() => {
    if (!url) return;

    const es = new EventSource(url, { withCredentials: true });

    es.addEventListener("connected", () => {
      setStatus("connected");
    });

    es.onopen = () => {
      setStatus("connected");
    };

    es.onerror = () => {
      setStatus("disconnected");
    };

    return () => {
      es.close();
    };
  }, [url]);

  return status;
}
